import { getSystemSettings } from '@/api/system'
import {  getCookie} from '@/utils/tools'
import store from '@/store'

// import { setAuthorityUrl, setAppSetting, setNasFileHost } from '@/utils/auth'

const system = {
  state: {
    fileDomain: '',
    backUpFileDomain: '',
    loadingSystemSettings: false,
    fileDirectory: [],
    isEnableSignalrNotice: false,
    signalrNoticeHubUrl: '',
    nasFileHost: '',
    appId: '',
    appSecret: '',
    authorityUrl: ''
  },
  mutations: {
    SET_ISENABLESIGNALRNOTICE: (state, { IsEnableSignalrNotice }) => {
      state.isEnableSignalrNotice = IsEnableSignalrNotice
    },
    SET_SIGNALRNOTICE_HUBURL: (state, { SignalrNoticeHubUrl }) => {
      state.signalrNoticeHubUrl = SignalrNoticeHubUrl
    },
    SET_FILE_DOMAIN: (state, { FileDomain }) => {
      state.fileDomain = FileDomain
    },
    SET_BACKUP_FILE_DOMAIN: (state, { BackUpFileDomain }) => {
      state.backUpFileDomain = BackUpFileDomain
    },
    SET_LOADING_SYSTEM_SETTINGS: (state, bool) => {
      state.loadingSystemSettings = bool
    },
    SET_FILE_DIRECTORY: (state, { FileDirectory }) => {
      state.fileDirectory = FileDirectory
    },
    SET_NAS_FILE_HOST: (state, { NasFileHost }) => {
      state.nasFileHost = NasFileHost
    },
    SET_AUTHORITY_URL: (state, { AuthorityUrl }) => {
      state.authorityUrl = AuthorityUrl
    },
    SET_APP_ID: (state, { AppId }) => {
      state.appId = AppId
    },
    SET_APP_SECRET: (state, { AppSecret }) => {
      state.appSecret = AppSecret
    }
  },
  actions: {
    async initSystemSetting ({ commit, state, dispatch }) {
      if (state.loadingSystemSettings) return
      commit('SET_LOADING_SYSTEM_SETTINGS', true)
      await getSystemSettings()
        .then(res => {
          // setNasFileHost(res.data.NasFileHost || '')
          // setAppSetting(res.data.AppSetting)
          // setAuthorityUrl(res.data.AuthorityUrl)

          commit('SET_AUTHORITY_URL', res.data)
          commit('SET_APP_ID', res.data.AppSetting)
          commit('SET_APP_SECRET', res.data.AppSetting)
          commit('SET_NAS_FILE_HOST', res.data)
          commit('SET_FILE_DOMAIN', res.data)
          commit('SET_BACKUP_FILE_DOMAIN', res.data)
          commit('SET_FILE_DIRECTORY', res.data)
          commit('SET_ISENABLESIGNALRNOTICE', res.data)
          commit('SET_SIGNALRNOTICE_HUBURL', res.data)
          // commit more if needed
          dispatch('setMenu', res.data.Hosts)
        })
        .catch(err => {
          commit('SET_LOADING_SYSTEM_SETTINGS', false)
          console.error('Fail to download system settings, please contact Administrator.', err)
        })
        .finally(() => {
        })
    },
    async downloadFile ({ state, dispatch }, { directory, path }) {
      console.log(store.state.classDetail.diver)
      if (!state.fileDomain) {
        await dispatch('initSystemSetting')
      }

      const dir = state.fileDirectory[directory] || directory
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      
      let url ='';
      if(directory=='TrainingResources'){
         url = `/static/pdf/web/viewer.html?file=${path}`
      }else{
        if(store.state.classDetail.diver){
          url = `/static/pdf/web/viewer.html?file=${path}`
        }else{
          url = `/static/pdf/web/viewer.html?file=${state.fileDomain}/${dir}/${path}`
        }
      }

      var client = getCookie("client")

      if (client=="tutorclient"&&isMac){
        if(directory=='TrainingResources'){
          window.location.href=url
        }else{
          window.open(`${url}`, '_blank')
        }
      }else{
        if(directory=='TrainingResources'){
          window.open(path, '_blank')
        }else{
          if(store.state.classDetail.diver)
          window.open(`${path}`, '_blank')
          else
          window.open(`${state.fileDomain}/${dir}/${path}`, '_blank')
        }
      } 
    },
    async downloadBackupFile ({ state, dispatch }, { directory, path }) {
      if (!state.backUpFileDomain) {
        await dispatch('initSystemSetting')
      }
      const dir = state.fileDirectory[directory] || directory
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      let url="";
      if(store.state.classDetail.diver) 
      url = `/static/pdf/web/viewer.html?file=${path}`
      else
      url = `/static/pdf/web/viewer.html?file=${state.backUpFileDomain}/${dir}/${path}`
      var client = getCookie("client")
      if (client=="tutorclient"&&isMac){
        window.open(`${url}`, '_blank')
      }else{
        if(store.state.classDetail.diver) 
        window.open(`${path}`, '_blank')
       else
        window.open(`${state.backUpFileDomain}/${dir}/${path}`, '_blank')
      } 
    }
  }
}
export default system
